// Korean translations
const common = {
  "nav.home": "홈",
  "nav.generator": "AI 생성기",
  "nav.pricing": "요금제",
  "nav.login": "로그인 / 회원가입",
  "nav.startFree": "무료로 시작하기",
  "nav.memberCenter": "멤버 센터",
  "nav.logout": "로그아웃",

  "hero.badge": "영원히 100% 무료 • 로그인 불필요",
  "hero.title1": "무료 AI 이미지",
  "hero.title2": "생성기",
  "hero.subtitle":
    "AI로 아이디어를 즉시 멋진 비주얼로 변환하세요.\n회원가입 없이, 무제한 생성, 완전 무료.",
  "hero.ctaPrimary": "무료로 만들기 시작",
  "hero.ctaSecondary": "사용 방법 보기",
  "hero.trust1": "신용카드 불필요",
  "hero.trust2": "무제한 사용",
  "hero.trust3": "상업적 권리",

  "features.badge": "기능",
  "features.title": "강력한 AI 이미지 생성",
  "features.subtitle":
    "크리에이터를 위해 설계된 최첨단 기능으로 차세대 AI 이미지 생성을 경험하세요",
  "features.f1.title": "텍스트에서 이미지",
  "features.f1.desc":
    "고급 AI 모델로 단어를 멋진 비주얼로 변환하세요. 원하는 것을 설명하기만 하면 됩니다.",
  "features.f2.title": "이미지에서 이미지",
  "features.f2.desc":
    "이미지를 업로드하여 다른 스타일로 변환하거나 품질을 향상시키세요.",
  "features.f3.title": "스타일 전환",
  "features.f3.desc":
    "이미지에 예술적 스타일을 적용하세요. 사실적인 것부터 애니메이션까지.",
  "features.f4.title": "초고속",
  "features.f4.desc":
    "최적화된 AI 인프라로 몇 초 만에 전문가 수준의 이미지를 생성하세요.",
  "features.f5.title": "개인정보 보호",
  "features.f5.desc":
    "제로 데이터 보존 정책. 프롬프트와 이미지는 서버에 저장되지 않습니다.",
  "features.f6.title": "무제한 & 무료",
  "features.f6.desc":
    "사용 제한 없음, 신용카드 불필요, 회원가입 불필요. 원하는 만큼 영원히 만드세요.",

  "gallery.badge": "갤러리",
  "gallery.title": "영감을 얻으세요",
  "gallery.subtitle": "커뮤니티가 만든 멋진 AI 생성 이미지를 탐색하세요",
  "gallery.cta": "직접 만들기",
  "gallery.clickToUse": "클릭하여 사용",
  "gallery.copyPrompt": "프롬프트 복사",
  "gallery.copied": "복사됨!",
  "gallery.usePrompt": "이것 사용",
  "gallery.hoverTip": "이미지에 마우스를 올려 프롬프트를 복사하거나 사용하세요",

  "stats.title": "수백만 명이 신뢰합니다",
  "stats.subtitle": "세계 최대 무료 AI 이미지 생성 커뮤니티에 참여하세요",
  "stats.s1.label": "활성 사용자",
  "stats.s1.value": "300만+",
  "stats.s1.desc": "월간 활성 사용자",
  "stats.s2.label": "생성된 이미지",
  "stats.s2.value": "1,530",
  "stats.s2.desc": "분당 생성 이미지 수",
  "stats.s3.label": "사용자 평점",
  "stats.s3.value": "4.9",
  "stats.s3.desc": "평균 품질 평점",

  "testimonials.badge": "사용자 후기",
  "testimonials.title": "크리에이터들의 이야기",
  "testimonials.subtitle":
    "크리에이터들이 AI를 활용해 생산성을 높이는 방법을 확인하세요",
  "testimonials.ratings":
    "25,017개 이상의 사용자 평점 기준, 평균 4.9/5점",
  "testimonials.t1.name": "Sophie Miller",
  "testimonials.t1.role": "프리랜서 디자이너",
  "testimonials.t1.content":
    "이 AI 이미지 생성기로 창의적 효율성이 10배 향상되었습니다! 이미지 품질은 상상을 초월하며 상업적 요구사항을 완벽히 충족합니다.",
  "testimonials.t2.name": "Michael Chen",
  "testimonials.t2.role": "크리에이티브 디렉터",
  "testimonials.t2.content":
    "고급 기능으로 모든 세부 사항을 정밀하게 제어할 수 있습니다. 시장에서 가장 강력한 AI 이미지 생성기입니다!",
  "testimonials.t3.name": "Sarah Wang",
  "testimonials.t3.role": "이커머스 매니저",
  "testimonials.t3.content":
    "이커머스 매니저로서 이 도구는 제품 쇼케이스 이미지를 빠르게 생성하는 데 도움이 됩니다.",
  "testimonials.t4.name": "David Liu",
  "testimonials.t4.role": "브랜드 디자이너",
  "testimonials.t4.content":
    "에디터로 브랜드 스타일 일관성을 유지할 수 있습니다. 이 AI 이미지 생성기는 정말 제 필요를 이해합니다.",
  "testimonials.t5.name": "Emma Zhang",
  "testimonials.t5.role": "콘텐츠 크리에이터",
  "testimonials.t5.content":
    "속도가 놀랍습니다! 몇 초 만에 전문가 수준의 이미지가 생성되어 프로젝트 주기가 크게 단축되었습니다.",
  "testimonials.t6.name": "Kevin Wu",
  "testimonials.t6.role": "게임 컨셉 아티스트",
  "testimonials.t6.content":
    "디테일 표현이 타의 추종을 불허합니다. 게임 개발자로서 컨셉 디자인의 필수 도구가 되었습니다.",

  "cta.title1": "멋진 AI 아트를",
  "cta.title2": "만들 준비가 되셨나요?",
  "cta.subtitle":
    "세계에서 가장 강력한 무료 AI 이미지 생성기를 사용하는 수백만 크리에이터와 함께하세요",
  "cta.button": "첫 번째 이미지 무료로 생성",
  "cta.note": "신용카드 불필요 • 회원가입 불필요 • 무제한 생성",

  "faq.badge": "자주 묻는 질문",
  "faq.title": "자주 묻는 질문",
  "faq.contact":
    "더 궁금한 점이 있으신가요? support@aiimagegenrator.com으로 문의하세요",
  "faq.q1": "이 AI 이미지 생성기는 무엇이며 어떻게 작동하나요?",
  "faq.a1":
    "저희 AI 이미지 생성기는 세계 최초의 완전 무료, 무제한 AI 이미지 생성 도구입니다. 등록이나 사용 제한 없이 고품질 이미지를 만들 수 있습니다.",
  "faq.q2": "이 AI 이미지 생성기는 정말 무료인가요?",
  "faq.a2": "네, 완전히 무료입니다! 숨겨진 요금 없음, 신용카드 불필요, 사용 제한 없음입니다.",
  "faq.q3": "다른 AI 이미지 생성기와 무엇이 다른가요?",
  "faq.a3":
    "여러 AI 모델에 걸친 지능형 라우팅으로 무제한 무료 사용을 제공하는 유일한 플랫폼입니다.",
  "faq.q4": "사용하려면 계정을 만들어야 하나요?",
  "faq.a4": "계정 불필요! 바로 방문하여 이미지 생성을 시작할 수 있습니다.",
  "faq.q5": "어떤 종류의 이미지를 만들 수 있나요?",
  "faq.a5":
    "사실적인 장면, 예술적 일러스트, 디지털 아트, 애니메이션 스타일 이미지 등 다양한 종류를 만들 수 있습니다.",
  "faq.q6": "개인정보는 어떻게 보호되나요?",
  "faq.a6":
    "프롬프트나 생성된 이미지를 서버에 저장하지 않으며 개인 정보도 필요하지 않습니다.",
  "faq.q7": "생성된 이미지를 상업적 목적으로 사용할 수 있나요?",
  "faq.a7":
    "네, 생성된 이미지의 권리는 귀하에게 있습니다. 개인 및 상업적 목적 모두에 사용할 수 있습니다.",
  "faq.q8": "모바일 기기에서 사용할 수 있나요?",
  "faq.a8":
    "현재 모바일 브라우저에서 잘 작동하는 웹사이트를 통해 접근할 수 있습니다.",

  "pricing.title": "간단하고 투명한 요금제",
  "pricing.subtitle": "창의적 필요에 맞는 완벽한 플랜을 선택하세요",
  "pricing.monthly": "월간",
  "pricing.yearly": "연간",
  "pricing.save17": "17% 절약",
  "pricing.popular": "가장 인기",
  "pricing.guarantee": "30일 환불 보장",
  "pricing.loginPrompt": "Pro로 업그레이드하려면 먼저 로그인하세요",
  "pricing.free.name": "무료",
  "pricing.free.desc": "AI 이미지 생성을 시험해보기에 완벽",
  "pricing.free.cta": "무료로 시작하기",
  "pricing.free.f1": "하루 10개 이미지",
  "pricing.free.f2": "표준 품질 (512x512)",
  "pricing.free.f3": "기본 스타일 & 필터",
  "pricing.free.f4": "커뮤니티 지원",
  "pricing.free.f5": "워터마크 이미지",
  "pricing.free.f6": "표준 생성 속도",
  "pricing.pro.name": "Pro",
  "pricing.pro.desc": "전문가 및 콘텐츠 크리에이터를 위한",
  "pricing.pro.cta": "Pro로 업그레이드",
  "pricing.pro.f1": "무제한 이미지",
  "pricing.pro.f2": "고품질 (1024x1024)",
  "pricing.pro.f3": "프리미엄 스타일 & 필터",
  "pricing.pro.f4": "우선 지원",
  "pricing.pro.f5": "워터마크 없음",
  "pricing.pro.f6": "빠른 생성 속도",
  "pricing.pro.f7": "일괄 생성 (최대 10개)",
  "pricing.pro.f8": "상업 라이선스",
  "pricing.pro.f9": "고급 AI 모델",
  "pricing.pro.f10": "이미지 업스케일링",
  "pricing.pro.saveYear": "$30/년 절약",
  "pricing.paypalCheckout": "PayPal로 구독 완료",
  "pricing.cancelPayment": "취소",
  "pricing.subscriptionSuccess": "구독 성공! Pro에 오신 것을 환영합니다!",

  "compare.title": "상세 비교",
  "compare.subtitle": "각 플랜에 포함된 내용 확인",
  "compare.feature": "기능",
  "compare.free": "무료",
  "compare.pro": "Pro",
  "compare.f1": "이미지 생성",
  "compare.v1.free": "무제한",
  "compare.v1.pro": "무제한",
  "compare.f2": "최대 해상도",
  "compare.v2.free": "1024x1024",
  "compare.v2.pro": "4096x4096",
  "compare.f3": "생성 속도",
  "compare.v3.free": "표준",
  "compare.v3.pro": "3배 빠름",
  "compare.f4": "일괄 생성",
  "compare.v4.free": "5개",
  "compare.v4.pro": "20개",
  "compare.f5": "스타일 옵션",
  "compare.v5.free": "기본",
  "compare.v5.pro": "고급",
  "compare.f6": "편집 도구",
  "compare.v6.free": "기본",
  "compare.v6.pro": "고급",
  "compare.f7": "광고",
  "compare.v7.free": "있음",
  "compare.v7.pro": "없음",
  "compare.f8": "우선 지원",
  "compare.v8.free": "없음",
  "compare.v8.pro": "있음",
  "compare.f9": "상업 라이선스",
  "compare.v9.free": "있음",
  "compare.v9.pro": "있음",
  "compare.f10": "워터마크",
  "compare.v10.free": "없음",
  "compare.v10.pro": "없음",

  "gen.title": "AI 이미지 생성기",
  "gen.subtitle":
    "AI로 멋진 이미지 생성 - 무료, 무제한, 로그인 불필요",
  "gen.mode": "생성 모드",
  "gen.textToImage": "텍스트에서 이미지",
  "gen.imageToImage": "이미지에서 이미지",
  "gen.aspectRatio": "화면 비율",
  "gen.style": "스타일",
  "gen.style.none": "스타일 없음",
  "gen.style.realistic": "사실적",
  "gen.style.anime": "애니메이션",
  "gen.style.artistic": "예술적",
  "gen.style.digital": "디지털 아트",
  "gen.promptLabel": "만들고 싶은 것을 설명하세요",
  "gen.promptPlaceholder":
    "생동감 있는 색상의 산 위의 아름다운 일몰...",
  "gen.promptTip":
    "💡 팁: 최상의 결과를 위해 구체적이고 자세하게 설명하세요",
  "gen.uploadLabel": "소스 이미지 업로드",
  "gen.uploadHint": "클릭하여 업로드하거나 드래그 앤 드롭",
  "gen.uploadSize": "PNG, JPG 최대 10MB",
  "gen.generateBtn": "이미지 생성",
  "gen.free": "무료",
  "gen.resultPlaceholder": "생성된 이미지가 여기에 표시됩니다",
  "gen.emptyPrompt": "이미지를 생성하려면 프롬프트를 입력하세요",
  "gen.promptPrefilled": "✨ 갤러리에서 프롬프트가 입력되었습니다! 생성 버튼을 클릭하여 이미지를 만드세요.",
  "gen.clearPrompt": "지우기",

  // 생성기 탭 & 새 키
  "gen.tabSingle": "단일 이미지",
  "gen.tabBatch": "일괄 생성",
  "gen.tabHistory": "히스토리",
  "gen.successMsg": "이미지가 성공적으로 생성되었습니다!",
  "gen.generating": "생성 중...",
  "gen.download": "이미지 다운로드",
  "gen.new": "새로 만들기",

  // 이미지 히스토리
  "history.title": "생성 히스토리",
  "history.empty": "아직 생성된 이미지가 없습니다",
  "history.emptyHint": "생성한 이미지가 여기에 표시됩니다",
  "history.clearAll": "전체 삭제",
  "history.clearConfirmTitle": "모든 히스토리를 삭제하시겠습니까?",
  "history.clearConfirmDesc": "모든 생성 히스토리가 영구적으로 삭제됩니다. 이 작업은 되돌릴 수 없습니다.",
  "history.cancel": "취소",
  "history.clearConfirm": "전체 삭제",
  "history.reuse": "이 프롬프트 사용",
  "history.download": "다운로드",
  "history.copyPrompt": "프롬프트 복사",
  "history.justNow": "방금",
  "history.minutesAgo": "{{count}}분 전",
  "history.hoursAgo": "{{count}}시간 전",
  "history.daysAgo": "{{count}}일 전",

  // 일괄 생성
  "batch.title": "일괄 생성",
  "batch.badge": "Pro 기능",
  "batch.countLabel": "생성할 이미지 수",
  "batch.images": "개",
  "batch.generateBtn": "{{count}}개 이미지 생성",
  "batch.generating": "생성 중",
  "batch.progressText": "{{done}} / {{total}}개 완료",
  "batch.results": "생성 결과",
  "batch.downloadAll": "전체 다운로드",
  "batch.hint": "왼쪽에 프롬프트를 입력한 후 여러 변형을 한 번에 생성하세요",

  // 이미지를 동영상으로
  "gen.tabI2V": "이미지→동영상",
  "i2v.title": "이미지를 동영상으로",
  "i2v.uploadTitle": "이미지를 업로드하거나 붙여넣기",
  "i2v.uploadHint": "클릭하여 업로드, 드래그 앤 드롭 또는 Ctrl+V로 붙여넣기",
  "i2v.uploadFormats": "PNG, JPG, WebP 최대 20MB",
  "i2v.changeImage": "변경",
  "i2v.effectLabel": "모션 효과",
  "i2v.effectZoomIn": "확대",
  "i2v.effectZoomOut": "축소",
  "i2v.effectPanLeft": "왼쪽",
  "i2v.effectPanRight": "오른쪽",
  "i2v.effectPanUp": "위로",
  "i2v.generateBtn": "동영상 생성",
  "i2v.generating": "생성 중",
  "i2v.progressHint": "프레임 렌더링 중, 잠시 기다려주세요...",
  "i2v.success": "동영상이 성공적으로 생성되었습니다!",
  "i2v.download": "동영상 다운로드",
  "i2v.regenerate": "다시 시도",
  "i2v.error": "동영상 생성에 실패했습니다. 다시 시도해주세요.",
  "i2v.invalidFile": "유효한 이미지 파일을 선택해주세요.",
  "i2v.fileTooLarge": "파일이 너무 큽니다. 최대 20MB입니다.",

  "footer.stayUpdated": "최신 정보 받기",
  "footer.newsletter":
    "새로운 기능 및 AI 이미지 생성 팁에 대한 최신 업데이트를 받으세요",
  "footer.emailPlaceholder": "이메일 주소",
  "footer.subscribe": "구독하기",
  "footer.product": "제품",
  "footer.features": "기능",
  "footer.company": "회사",
  "footer.legal": "법적 정보",
  "footer.aiGenerator": "AI 생성기",
  "footer.pricing": "요금제",
  "footer.textToImage": "텍스트에서 이미지",
  "footer.imageToImage": "이미지에서 이미지",
  "footer.styleTransfer": "스타일 전환",
  "footer.aboutUs": "회사 소개",
  "footer.contact": "문의하기",
  "footer.privacy": "개인정보 처리방침",
  "footer.terms": "이용약관",
  "footer.copyright": "© 2025 AI Image Generator. All rights reserved.",
  "footer.poweredBy": "Powered by Readdy",

  // Pro Banner
  "proBanner.badge": "기간 한정 혜택",
  "proBanner.title": "Pro로 궁극의 크리에이티브 파워 해제",
  "proBanner.subtitle": "4K 해상도, 3배 빠른 생성, 일괄 처리, 광고 없음으로 AI 아트를 한 단계 업그레이드하세요.",
  "proBanner.f1": "3배 빠름",
  "proBanner.f2": "4K 해상도",
  "proBanner.f3": "일괄 생성",
  "proBanner.f4": "광고 없음",
  "proBanner.discount": "48% 할인 — 기간 한정",
  "proBanner.cta": "지금 Pro로 업그레이드",
  "proBanner.guarantee": "30일 환불 보장",

  // Member Center
  "member.loginRequired": "로그인 필요",
  "member.loginDesc": "멤버 센터에 접근하고 구독을 관리하려면 로그인하세요.",
  "member.backHome": "홈으로 돌아가기",
  "member.freePlan": "무료 플랜",
  "member.proPlan": "Pro 플랜",
  "member.currentPlan": "현재 플랜",
  "member.planType": "플랜 유형",
  "member.freePlanLabel": "무료",
  "member.resolution": "최대 해상도",
  "member.speed": "생성 속도",
  "member.speedStandard": "표준",
  "member.speed3x": "3배 빠름",
  "member.batch": "일괄 생성",
  "member.batch5": "최대 5개",
  "member.batch20": "최대 20개",
  "member.watermark": "워터마크",
  "member.noWatermark": "워터마크 없음",
  "member.hasWatermark": "있음",
  "member.usageStats": "사용 통계",
  "member.todayUsage": "오늘 사용량",
  "member.totalGenerated": "총 생성 수",
  "member.memberSince": "가입일",
  "member.upgradeTitle": "Pro로 업그레이드하여 완전한 경험을",
  "member.upgradeDesc": "4K 해상도, 3배 속도, 일괄 생성, 워터마크 없음, 광고 없음을 해제하세요.",
  "member.upgradeCta": "Pro로 업그레이드",
  "member.proBenefits": "Pro 혜택",
  "member.benefit1": "무제한 이미지",
  "member.benefit2": "4K 해상도",
  "member.benefit3": "3배 빠른 속도",
  "member.benefit4": "일괄 생성",
  "member.benefit5": "광고 없음",
  "member.benefit6": "상업 라이선스",
};

// Defensive export – guarantees the module always provides an object.
export default typeof common === "object" && common !== null ? common : {};

